webpackJsonp([89],{

/***/ 2382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestLoader_vue__ = __webpack_require__(3539);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7729ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestLoader_vue__ = __webpack_require__(4174);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4156)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7729ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/selfEvaluationTests/TestLoader.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d7729ac", Component.options)
  } else {
    hotAPI.reload("data-v-7d7729ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		var tests = [{
			id: 'psychosocial-risks',
			componentName: 'PsicosocialRisksTest',
			title: this.$i18n.t('tests.psychosocial-risks.title'),
			only360Users: true
		}, {
			id: 'ryff-scale',
			componentName: 'RyffScaleTest',
			title: this.$i18n.t('tests.ryff-scale.title'),
			alias: 'bienestar-psicologico',
			only360Users: true
		}, {
			id: 'findrisk',
			componentName: 'FindRiskTest',
			title: this.$i18n.t('tests.findrisk.title')
		}, {
			id: 'nicotine-dependency',
			componentName: 'NicotineDependencyTest',
			title: this.$i18n.t('tests.nicotine-dependency.title')
		}, {
			id: 'mediterranean-diet',
			componentName: 'MediterraneanDietTest',
			title: this.$i18n.t('tests.mediterranean-diet.title')
		}, {
			id: 'stress',
			componentName: 'StressTest',
			title: this.$i18n.t('tests.stress.title'),
			only360Users: true
		}, {
			id: 'sleep-quality',
			componentName: 'SleepQualityTest',
			title: this.$i18n.t('tests.sleep-quality.title')
		}, {
			id: 'anxiety-beck',
			componentName: 'AnxietyBeckTest',
			title: this.$i18n.t('tests.anxiety-beck.title')
		}, {
			id: 'physical-activity',
			componentName: 'PhysicalActivityTest',
			title: this.$i18n.t('tests.physical-activity.title'),
			only360Users: true
		}, {
			id: 'cardiovascular-risk',
			componentName: 'CardiovascularRiskTest',
			title: this.$i18n.t('tests.cardiovascular-risk.title')
		}, {
			id: 'general-health',
			componentName: 'GeneralHealthTest',
			title: this.$i18n.t('tests.general-health.title')
		}, {
			id: 'interpersonal-relationships',
			componentName: 'InterpersonalRelationshipsTest',
			title: this.$i18n.t('tests.interpersonal-relationships.title'),
			only360Users: true
		}, {
			id: 'social-skills',
			componentName: 'SocialSkillsTest',
			title: this.$i18n.t('tests.social-skills.title')
		}, {
			id: 'work-environment',
			componentName: 'WorkEnvironmentTest',
			title: this.$i18n.t('tests.work-environment.title'),
			only360Users: true
		}];
		return {
			testComponent: null,
			tests: tests
		};
	},
	created: function created() {
		this.loadTest();
	},
	metaInfo: function metaInfo() {
		return this.$helpers.buildMetaInfo({ appName: 'opensalud', appTagLine: 'opensalud' });
	},

	methods: {
		loadTest: function loadTest() {
			var _this = this;

			try {
				var testObj = this.tests.find(function (test) {
					return test.id === _this.$route.params.testId || test.alias === _this.$route.params.testId;
				});
				if (testObj.only360Users && !this.$store.getters['session/userHasCompanies']) {
					this.$store.commit('setErrorPageMessage', this.$t('errorMessages.only-subscribed-users'));
					this.$router.push('/error/unauthorized?returnUrl=' + this.$route.fullPath);
					return;
				}
				this.$set(this.$route.meta.title, 'text', testObj.title);
				this.testComponent = function () {
					return __webpack_require__(4158)("./" + testObj.componentName);
				};
			} catch (error) {
				this.$router.push('/error/not-found');
			}
		}
	}
});

/***/ }),

/***/ 4156:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4157);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("8eaac786", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d7729ac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TestLoader.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d7729ac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TestLoader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4157:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 4158:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AnxietyBeckTest": [
		3540,
		143
	],
	"./AnxietyBeckTest.vue": [
		3540,
		143
	],
	"./CardiovascularRiskTest": [
		3542,
		135
	],
	"./CardiovascularRiskTest.vue": [
		3542,
		135
	],
	"./FindRiskTest": [
		3544,
		142
	],
	"./FindRiskTest.vue": [
		3544,
		142
	],
	"./GeneralHealthTest": [
		3546,
		141
	],
	"./GeneralHealthTest.vue": [
		3546,
		141
	],
	"./InterpersonalRelationshipsTest": [
		3548,
		134
	],
	"./InterpersonalRelationshipsTest.vue": [
		3548,
		134
	],
	"./MediterraneanDietTest": [
		3550,
		140
	],
	"./MediterraneanDietTest.vue": [
		3550,
		140
	],
	"./NicotineDependencyTest": [
		3552,
		139
	],
	"./NicotineDependencyTest.vue": [
		3552,
		139
	],
	"./OpensaludScorecard": [
		2381,
		8
	],
	"./OpensaludScorecard.vue": [
		2381,
		8
	],
	"./PhysicalActivityTest": [
		3554,
		133
	],
	"./PhysicalActivityTest.vue": [
		3554,
		133
	],
	"./PsicosocialRisksTest": [
		3556,
		129
	],
	"./PsicosocialRisksTest.vue": [
		3556,
		129
	],
	"./RyffScaleTest": [
		3558,
		138
	],
	"./RyffScaleTest.vue": [
		3558,
		138
	],
	"./SleepQualityTest": [
		3560,
		137
	],
	"./SleepQualityTest.vue": [
		3560,
		137
	],
	"./SocialSkillsTest": [
		3562,
		132
	],
	"./SocialSkillsTest.vue": [
		3562,
		132
	],
	"./StressTest": [
		3564,
		131
	],
	"./StressTest.vue": [
		3564,
		131
	],
	"./TestLoader": [
		2382
	],
	"./TestLoader.vue": [
		2382
	],
	"./TestTemplate": [
		2524,
		144
	],
	"./TestTemplate.vue": [
		2524,
		144
	],
	"./WorkEnvironmentTest": [
		3566,
		136
	],
	"./WorkEnvironmentTest.vue": [
		3566,
		136
	],
	"./mood/MoodSelector": [
		3036,
		128
	],
	"./mood/MoodSelector.vue": [
		3036,
		128
	],
	"./mood/MoodTracker": [
		2795,
		130
	],
	"./mood/MoodTracker.vue": [
		2795,
		130
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4158;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 4174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.testComponent, { tag: "component" })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7729ac", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/89.481d9d91dc52a08e6296.js